import Icon from 'utils/components/icon';
import classNames from 'classnames';
import React from 'react';

import styles from './DropDownChevron.module.scss';

export interface DropDownChevronProps {
  open: boolean;
  onClick?: () => void;
}

export const DropDownChevron = (props: DropDownChevronProps) => {
  const { open, onClick } = props;

  return (
    <div className={styles.iconContainer} onClick={onClick}>
      <Icon
        className={classNames(styles.icon, styles.chevron, {
          [styles.isOpen]: open
        })}
        name="chevron-down"
      />
    </div>
  );
};
